import React from 'react';
import { SimpleModal } from '../../../../components/SimpleModal';
import { DoctorScheduling } from '../../../../components/Icons';
import { SystemUnavailableProps } from '../../../../components/SystemUnavailable';
import { Button } from '../../../../components';

export type DoctorFirstStepModalProps = {
  scheduleWithNurse: () => void;
  scheduleWithDoctor: () => void;
} & SystemUnavailableProps;

export const DoctorFirstStepModal: React.FC<DoctorFirstStepModalProps> = ({
  visible,
  onClose,
  scheduleWithDoctor,
  scheduleWithNurse
}) => {
  return (
    <SimpleModal
      visible={visible}
      onClose={onClose}
      title="Avaliações iniciais"
      subtitle="<div><p>Para avaliações iniciais recomendamos que você agende uma consulta com a enfermagem.</p></br><p>Nossos enfermeiros estão prontos para atender e acolher suas necessidades.</p></div>"
      mainIcon={<DoctorScheduling />}
      customFooterContainer={
        <>
          <Button disabled={!visible} type="button" title="Agendar com enfermeiro" onClick={scheduleWithNurse} />
          <Button disabled={!visible} tertiary type="button" title="Agendar com médico" onClick={scheduleWithDoctor} />
        </>
      }
    />
  );
};
